import { colors } from '../../colors';
var service = {
  bgColor: colors.white,
  borderColor: colors.overcast,
  bgColorBlade: colors.white,
  carouselDotColor: colors.petsuitesPurple,
  linkColor: colors.petsuitesPurple,
  cardRadius: '20px',
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default service;